import { render, staticRenderFns } from "./yuList.vue?vue&type=template&id=599e65c4&scoped=true"
import script from "./yuList.vue?vue&type=script&lang=js"
export * from "./yuList.vue?vue&type=script&lang=js"
import style0 from "./yuList.vue?vue&type=style&index=0&id=599e65c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599e65c4",
  null
  
)

export default component.exports